import React from 'react';
import {Create ,SimpleForm , ImageInput,ImageField, CheckboxGroupInput ,SelectInput,TextInput , ReferenceField ,
    RadioButtonGroupInput, FileInput, FileField ,ArrayInput,SimpleFormIterator,ReferenceInput , 
    required , number , FormDataConsumer , BooleanInput, ReferenceArrayInput, translate, 
    Toolbar, SaveButton
} from "react-admin";
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { Actions, Resources, useHasPermissions } from '../lib/react-admin-loopback';

const useStyles = makeStyles({
    inlineBlock: { display: 'inline-flex', marginRight: '1rem' }, /* 컴포넌트 1열 배열 스타일 */
    inlineBlock1: { display: 'flex', flexDirection: 'row' , marginRight: '1rem' },
    cardtitle: {
        fontSize: 14,
      },
});

const validateRequire= [required('필수 입력')];
const validateNumber = number('숫자 형식으로 입력해 주세요');
const validateReNum = [required('필수 입력') , number('숫자 형식으로 입력해 주세요')]
export const MenuCreate = props => {

  const hasCreatePermission = useHasPermissions(
    Resources.Menu,
    Actions.Create,
    () => {
      alert('권한이 없습니다.');
      props.history.push('/menus');
    }
  );

    const classes = useStyles();
    return (

    <Create {...props}>
        <SimpleForm>
        <ReferenceInput  validate={validateRequire} perPage={500} source ='supplierId' label="공급자" fullWidth reference="suppliers" >
                <SelectInput  optionText="name"/>
            </ReferenceInput>
            <TextInput validate={validateNumber} source ="ratingFooding" label="평가점수" />
            <TextInput validate={validateRequire} source ="name" label="메인(메뉴명)" />
            
            <ArrayInput source ="subMenu" label="서브메뉴">
                <SimpleFormIterator>
                    <TextInput label ="서브메뉴명" source="name"></TextInput>    
                </SimpleFormIterator>
            </ArrayInput>
            <BooleanInput label="조식" source="breakfast" formClassName={classes.inlineBlock}/>
            <BooleanInput label="중식" source="lunch" formClassName={classes.inlineBlock}/>
            <BooleanInput label="석식" source="dinner" formClassName={classes.inlineBlock}/>
            <div />
            <TextInput validate={validateNumber} source ="price" label="단가"  formClassName={classes.inlineBlock}/>
            <TextInput validate={validateNumber} source ="orderQtyMin" label="최소수량" formClassName={classes.inlineBlock} />
            <TextInput validate={validateNumber} source ="orderQtyMax" label="최대수량" formClassName={classes.inlineBlock} />
            <div />
            <ArrayInput source="menuCategory" label="카테고리">
                <SimpleFormIterator>
                    <ReferenceInput  formClassName={classes.inlineBlock} source ='categoryLv1Id' label="1차카테고리" reference="menuCategoryLv1s" >
                        <SelectInput  optionText="name"/>
                    </ReferenceInput>
                    <FormDataConsumer formClassName={classes.inlineBlock}  >
                        {({
                            formData, // The whole form data
                            scopedFormData, // The data for this item of the ArrayInput
                            getSource, // A function to get the valid source inside an ArrayInput
                            ...rest
                        }) =>
                            scopedFormData && scopedFormData.categoryLv1Id ? (
                                
                                <ReferenceInput  source ={getSource('categoryLv2Id')} label="2차카테고리"  reference="menuCategoryLv2s" filter={{lv1Id : scopedFormData.categoryLv1Id}} >
                                    <SelectInput  optionText="name"/>
                                </ReferenceInput>
                            ) : null
                        }
                    </FormDataConsumer>
                </SimpleFormIterator>
            </ArrayInput>
            <TextInput source ="menuDesc" label="메뉴설명"  fullWidth/>
            <ReferenceInput  source ='serviceTypeId' label="취식형태" reference="commonCodes" filter={{type: '08'}}>
                <SelectInput  optionText="desc"/>
            </ReferenceInput>
            {/* <ImageInput source="menuPhotoFile" label="메뉴이미지" multiple={false} accept="image/*">
                <ImageField source="src" title="title" />
            </ImageInput>
            <ReferenceField source="menuPhotoFile" reference="uploadedFiles" label="메뉴이미지">
                <ImageField source="fullPath" />
            </ReferenceField> */}
            <ImageInput label="메뉴이미지" source="menuPhotoFile" allowEmpty multiple={false}>
                <ImageField source="src" />
            </ImageInput>
            <TextInput validate={validateNumber} source ="packageCount" label="용기수"  formClassName={classes.inlineBlock}/>
            <ReferenceInput source ="curationGenderId" fullWidth ="true" label="태그1" reference="commonCodes" filter={{type: '03'}}>
                <RadioButtonGroupInput  optionText="desc" />
            </ReferenceInput>

            {/* 정재형 확인  */}
            <ReferenceArrayInput  source ='curationAge' format={v => Array.isArray(v) ? v.map(a => a.id ? a.id: a) : []} 
            parse={ids => ids.map(id => ({id}))}
            label="태그2" fullWidth = "true" reference="commonCodes" filter={{type: '06'}} sort={{ field: 'sort', order: 'ASC' }}>
                <CheckboxGroupInput optionText="desc" />
            </ReferenceArrayInput>
                
            <RadioButtonGroupInput source ="curation" fullWidth ="true" label="큐레이션" choices={[
                { id: true , name: 'on' },
                { id: false , name: 'off' },
            ]} />
        </SimpleForm>
    </Create>
)};

